import { closeSnackbar, openSnackbar } from "@/store/uiSlice";
import { useAppDispatch } from ".";
import { AlertColor } from "@mui/material";

const useSnackbar = () => {
  const dispatch = useAppDispatch();

  const open = (message: string, severity: AlertColor = "info") => {
    dispatch(
      openSnackbar({
        severity,
        message,
      })
    );
  };

  const close = () => {
    dispatch(closeSnackbar());
  };

  return [open, close];
};

export default useSnackbar;
